import React from "react";
import {
  TextField as MuiTextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";

function GenericTextField({
  name,
  label,
  type = "string",
  multiline = false,
  rows = 0,
  icon,
  select = false,
  options = [],
  value,
  onChange,
  onBlur,
  fullWidth = true,
  placeholder = "",
  error = false,
  helperText = "",
}) {
  const hasIcon = Boolean(icon);

  return (
    <MuiTextField
      name={name}
      type={type}
      label={label}
      placeholder={placeholder}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      select={select}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      InputProps={{
        startAdornment: hasIcon ? (
          <InputAdornment position="start">{icon}</InputAdornment>
        ) : undefined,
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          color: "black", // Text color
          "& fieldset": {
            borderColor: error ? "error.main" : "grey",
            borderWidth: "2px", // Default border color
          },
          "&:hover fieldset": {
            borderColor: error ? "error.main" : "#23A215", // Hover border color
          },
          "&.Mui-focused fieldset": {
            borderColor: error ? "error.main" : "#23A215", // Focus border color (when clicked)
          },
          "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px white inset",
            WebkitTextFillColor: "black",
            fontSize: "14px",
          },
          "& input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
            WebkitBoxShadow: "0 0 0 100px white inset",
            WebkitTextFillColor: "black",
            fontSize: "14px",
          },
        },
        "& .MuiInputLabel-root": {
          color: error ? "error.main" : "black", // Default label color
          "&.Mui-focused": {
            color: error ? "error.main" : "#000", // Label color on focus
          },
        },
      }}
      InputLabelProps={{
        shrink: multiline || select || hasIcon || type === "date" ? true : undefined,
      }}// Force shrink if multiline, select, or icon exists
    >
      {select &&
        options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </MuiTextField>
  );
}

export default GenericTextField;